import { Component } from '@angular/core';

@Component({
  selector: 'ff-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
    Created with ♥ by <b><a href="https://redwolfsecurity.com" target="_blank">Redwolf Security</a></b> 2020
    </span>
    <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div>
  `,
})
export class FooterComponent {
}
